
import Vue from "vue";
import TempStarsTableTitle from "@/components/shared/TempStarsTableTitle/TempStarsTableTitle.vue";
import { triggerCronJob } from "@/api";

export default Vue.extend({
  name: "CronTrigger",
  components: {
    TempStarsTableTitle
  },
  data: () => ({
    loading: null as string | null,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "success",
    headers: [
      { text: "Job Name", value: "text" },
      { text: "Description", value: "description" },
      { text: "Action", value: "action", sortable: false, align: "end" }
    ],
    cronJobs: [
      { text: "Billing: Temp Jobs", value: "billing-temp-jobs", description: "Process billing for completed temp shifts" },
      { text: "Shift Reminders", value: "shift-reminders", description: "Send upcoming shift reminders" },
      { text: "Hire Jobs Expiration", value: "hire-jobs-expiration", description: "Check and expire old hire jobs" },
      { text: "Reset 'Available Now'", value: "reset-available-now", description: "Reset hygienist availability status" },
      { text: "Pull Jobs", value: "pull-jobs", description: "Sync jobs from external sources if applicable" },
      { text: "Membership Update", value: "membership-update", description: "Calculate membership tiers/scores" },
      { text: "Check Offers Expiration", value: "check-offers-expiration", description: "Expire offers that timed out" },
      { text: "Check Jobs Expiration", value: "check-jobs-expiration", description: "Expire jobs past start date" },
      { text: "Send Delayed Notifications", value: "send-delayed-notifications", description: "Process queued push notifications" },
      { text: "Talent GHR Top-ups", value: "talent-ghr-topups", description: "Process pending GHR top-up payouts for talent" }
    ]
  }),
  methods: {
    async runJob(job: any) {
      this.loading = job.value;
      try {
        await triggerCronJob(job.value);
        this.showSnackbar(`Job ${job.text} triggered successfully`, "success");
      } catch (error) {
        const err = error as any;
        this.showSnackbar(`Failed to trigger ${job.text}: ${err.message}`, "error");
      } finally {
        this.loading = null;
      }
    },
    showSnackbar(text: string, color: string) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    }
  }
});
